<template>
    <select ref="province" @change="onProvinceSelected" class="form-control"></select>
</template>

<script>
	export default {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: ['cname', 'value'],
		data() {
			return {
				id: Math.random().toString().replace(".",""),
				selectedValue: this.value,
				componentName: 'province'
			}
		},
		mounted() {
			this.initProvince()
		},
		methods: {
            onProvinceSelected(event) {
                this.$emit('province-selected', $(event.target).find("option:selected").data("id"))
				this.$emit('province-changed', {
					province: $(event.target).val(),
					component: this.componentName
				})
            },
			setSelectedValue(newValue) {
                this.selectedValue = newValue
            },
			getSelectedValue() {
                return this.selectedValue
            },
			valueChanged(value) {
				this.$emit('province-selected', value)
			},
			initProvince() {
				const $select = $(this.$refs.province)

                $select.attr("id", this.id)
                $select.html('<option value="">Seleziona provincia</option>')

				if(this.selectedValue && this.selectedValue.hasOwnProperty("long_name")) {
					this.selectedValue = this.value["long_name"]
				}

                this.loadItalianProvinces().then((res) => {
                    this.writeOptionsInSelect($select, "long_name", "long_name", res.provinces, this.selectedValue, ["id"]);

                    const $selectedOption = $select.find("option:selected")
                    if($selectedOption.length) {
                        const provinceId = $selectedOption.data("id")
                        if(provinceId) {
                            this.$emit('province-selected', provinceId)
                        }
                    }
                });
			},
			getSelect() {
				return $(this.$refs.province)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/purchases/VoucherPartecipantProvince.vue